import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAudienceList = Loadable({
  loader: function loader() {
    return import('../Audiences/AudienceList.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAudienceList;